import { type AddFlagProps } from '@databases/flags-types';
// FIXME circular dependency between service-container and flags
// eslint-disable-next-line workspaces/require-dependency
import { container } from '@databases/service-container';
import { useCallback } from 'react';

import { type ContentTypesFlagProps } from '@canvas/frame-api-types';

export function useFlags() {
  const addFlag = useCallback((props: AddFlagProps) => {
    const flagsManager = container.resolve('FlagsManager');

    // this method cannot be destructured because it is a class and will lose "this" context
    flagsManager.addFlag(props);
  }, []);

  const clearFlags = useCallback(() => {
    const flagsManager = container.resolve('FlagsManager');

    return flagsManager.clearFlags();
  }, []);

  const showFlag = useCallback((props: ContentTypesFlagProps) => {
    const flagsManager = container.resolve('FlagsManager');

    flagsManager.showFlag(props);
  }, []);

  const hideFlag = useCallback((flagId: string) => {
    const flagsManager = container.resolve('FlagsManager');

    flagsManager.hideFlag(flagId);
  }, []);

  const hideAllFlags = useCallback(() => {
    const flagsManager = container.resolve('FlagsManager');

    flagsManager.hideAllFlags();
  }, []);

  return {
    addFlag,
    clearFlags,
    showFlag,
    hideFlag,
    hideAllFlags
  };
}
